<template>
    <div>
        <h2 class="text-xl text-theme-base">
            Redes
            <strong class="text-theme-primary">sociales</strong>
        </h2>

        <p v-if="!value.length" class="text-sm text-theme-muted mt-6">
            Todavía no agregaste redes sociales.
        </p>

        <VueDraggable
            v-else
            v-model="localValue"
            tag="div"
            handle=".drag-handle"
            animation="200"
            class="space-y-3 mt-6"
        >
            <div
                v-for="item in value"
                :key="item.key"
                class="flex items-center gap-2"
            >
                <span
                    class="drag-handle cursor-grab select-none px-1 text-theme-muted"
                >
                    ⠿
                </span>
                <social-network-url-input
                    class="flex-1"
                    :label="networkOption(item.key).label"
                    :icon="networkOption(item.key).icon"
                    :base-url="networkOption(item.key).baseUrl"
                    :placeholder="networkOption(item.key).placeholder"
                    :value="item.url"
                    @input="updateUrl(item.key, $event)"
                />
                <button
                    type="button"
                    class="text-theme-danger text-sm font-medium hover:opacity-80"
                    @click="removeNetwork(item.key)"
                >
                    Quitar
                </button>
            </div>
        </VueDraggable>

        <div class="mt-4">
            <app-button type="button" @click="pickerOpen = true">
                Agregar red social
            </app-button>
        </div>

        <AppDialog v-model="pickerOpen" size="sm">
            <template #header>
                <h2 class="text-lg font-semibold text-theme-base">
                    Agregar red social
                </h2>
            </template>
            <social-network-picker
                :options="availableOptions"
                :value="[]"
                @input="onNetworkPicked"
            />
        </AppDialog>
    </div>
</template>

<script>
import VueDraggable from "vuedraggable";

import { SOCIAL_NETWORK_OPTIONS } from "@/common/fields/social-networks";

import AppDialog from "@/components/utils/AppDialog.vue";
import SocialNetworkPicker from "@/components/utils/SocialNetworkPicker.vue";
import SocialNetworkUrlInput from "@/components/utils/SocialNetworkUrlInput.vue";

export default {
    name: "SocialNetworksEditor",
    components: {
        AppDialog,
        SocialNetworkPicker,
        SocialNetworkUrlInput,
        VueDraggable
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        // Cuando esta editor.vue vive detrás de un modal que ya es en sí
        // mismo la acción de "editar redes sociales", no tiene sentido
        // pedir un segundo click para llegar al picker si todavía no hay
        // ninguna agregada. header.vue, en cambio, embebe este componente
        // directo en la página (no detrás de un modal), así que ahí no se
        // activa: abrir el picker solo al montar sorprendería antes de que
        // el usuario llegue a esa sección.
        autoOpenWhenEmpty: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        pickerOpen: false
    }),
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        },
        availableOptions() {
            const addedKeys = this.value.map((item) => item.key);
            return SOCIAL_NETWORK_OPTIONS.filter(
                (option) => !addedKeys.includes(option.key)
            );
        }
    },
    mounted() {
        if (this.autoOpenWhenEmpty && this.value.length === 0) {
            this.pickerOpen = true;
        }
    },
    methods: {
        networkOption(key) {
            return (
                SOCIAL_NETWORK_OPTIONS.find((option) => option.key === key) ||
                {}
            );
        },
        updateUrl(key, url) {
            this.$emit(
                "input",
                this.value.map((item) =>
                    item.key === key ? { ...item, url } : item
                )
            );
        },
        removeNetwork(key) {
            this.$emit(
                "input",
                this.value.filter((item) => item.key !== key)
            );
        },
        onNetworkPicked(keys) {
            const [newKey] = keys;
            if (!newKey) return;
            this.$emit("input", [...this.value, { key: newKey, url: "" }]);
            this.pickerOpen = false;
        }
    }
};
</script>
